module.exports = __webpack_public_path__ + "static/img/product1.1330dc50.png";